import { Modal, Image } from 'antd';
import { useRef, useState, useEffect } from 'react';
import Media from '../../assets/imgage/wordBook/Media.png';

const ModalLuckyWord = ({ isOpen = false, onClose , luckyImg}) => {

  useEffect(() => {
  }, []);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={375}
      className="custom-lucky-word-modal"
    >
      <div className="bHeader">
        <a className="btnCloseModal" onClick={onClose}></a>
      </div>
      <div className="bInner">
        <div className="bDetails">
              <h2>ยินดีด้วย!</h2>
              <h3>คุณได้ Lucky word</h3>
              <h3>รับเลยทันที! ของรางวัลสุดพิเศษ</h3>
              <div className="bClover">
                <Image preview={false} src={luckyImg}></Image>
              </div>
              <p>กดรับของรางวัลที่ Wordbook</p>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLuckyWord;
